import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import AdminLogin from "@/components/admin/AdminLogin";
import AdminDashboard from "@/components/admin/AdminDashboard";
import ThankYou from "@/components/ThankYou";
import { Toaster } from "@/components/ui/sonner";

// Fire TikTok Pixel page view on every client-side route change
function TikTokPageView() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window !== "undefined" && window.ttq && typeof window.ttq.page === "function") {
      window.ttq.page();
    }
  }, [location.pathname]);
  return null;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <TikTokPageView />
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/login" element={<AdminLogin />} />
      </Routes>
      <Toaster position="top-right" />
    </BrowserRouter>
  </React.StrictMode>,
);
